var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManApplying01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 936 656"
    },
    viewBox: "0 0 936 656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#f0f2f5}.st1{fill:#eae7d8}.st2{fill:#d6d3c4}.st3{fill:#212122}.st4{fill:#0e100f}.st5{fill:#fe9f73}.st6{fill:teal}.st7{fill:#025b59}.st8{fill:#e28037}.st10{fill:#f99747}.st11{fill:#f07162}.st12{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 41v608h453V141L655 41z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M753 141 656 41v100z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M706 225H412c-3 0-5-2-5-5 0-2 2-5 5-5h294c3 0 4 3 4 5 0 3-2 5-4 5zM706 270H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 315H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 405H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 450H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 360H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 494H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 539H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM706 584H412c-3 0-5-2-5-5s2-5 5-5h294c3 0 4 2 4 5s-2 5-4 5zM386 225h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 270h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 315h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 360h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 405h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 450h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 494h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 539h-42v-39h42v39zm-38-4h34v-31h-34v31zM386 584h-42v-39h42v39zm-38-4h34v-31h-34v31z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m364 218-1-3a725 725 0 0 0-9-20l2 1 8 16 20-34a1 1 0 1 1 2 1l-21 36-1 3zM364 261l-1-3a725 725 0 0 0-9-20l2 1 8 16 20-34a1 1 0 1 1 2 1l-21 36-1 3zM364 306l-1-2a725 725 0 0 0-9-20l2 1 8 15 20-33a1 1 0 1 1 2 1l-21 36-1 2zM364 352l-1-3a725 725 0 0 0-9-19h2l8 16 20-34a1 1 0 1 1 2 2l-21 35-1 3zM364 397l-1-2a725 725 0 0 0-9-20l2 1 8 15 20-33a1 1 0 1 1 2 1l-21 36-1 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M424 81h10c5 0 8 1 10 3 3 1 4 4 4 7l-2 7-6 3 2 2 2 2 11 17h-4l-6-10-4-5-2-3-3-1-5-1h-3v20h-4V81zm4 3v15h9l3-1 3-2 1-5-2-5-7-2h-7zM458 122V81h22v3h-19v16h19v2h-19v17h20v3h-23zM507 87l-5-3-4-1c-3 0-5 1-7 3s-2 3-2 5l2 4 6 4 1 1 8 4 2 3v4c0 4-1 6-3 8s-5 4-9 4l-5-1c-2 0-4-2-5-3v-4c2 2 3 3 5 3l5 2c3 0 5-1 7-3s2-3 2-6l-2-4c-1-1-3-3-7-4l-8-5c-2-2-2-4-2-7s1-6 3-8l8-2h5l5 2v4zM518 105c0 4 1 8 4 10s6 4 10 4 7-1 10-4 3-6 3-10V81h4v24c0 5-2 10-5 13s-7 5-12 5-10-2-13-5-4-8-4-13V81h3v24zM558 122V81h3l16 19 15-19h4v41h-4V86l-15 19-16-19v36h-3zM605 122V81h22v3h-19v16h19v2h-19v17h20v3h-23z",
    className: "st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M934 653H0l-2-2 2-2h934l2 2c0 2-1 2-2 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M896 649h4l-9-138h-9zM761 649h-4l9-138h9z",
    className: "st4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M927 318h-83l-44 195 95-10z",
    className: "st0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m736 491 142 2c5 0 10-3 11-9l29-160c0-4 5-7 9-6s6 5 6 9l-33 181-2 4c-2 4-6 7-11 7H737c-7 0-13-6-13-13s5-15 12-15z",
    className: "st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M878 494c6 0 10-4 11-10l29-160 3-4c2-1 4-2 6-1v-2c-2 0-5 0-6 2l-4 5-29 160c-1 5-5 9-10 9v1zM824 520l59-1c16 2 18-12 18-13l3-19v-1l-1 1-3 19c0 1-2 14-17 12h-59l-1 1 1 1z",
    className: "st4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M895 319h29v-2h-29l-1 1 1 1z",
    className: "st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m860 382-10 4-10 5-17 3 2 2c-21 3-85 5-95 6-7 1-13 9-17 15l6 4 56-2-5 14c35 2 83 2 92-13 8-11 1-28-2-38zM644 631l43 1v-40l-42-5z",
    className: "st5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M775 491h62l20-1c18-4 22-60 2-94s-91 71-91 71l7 24z",
    className: "st6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M709 633h42l1-39-43-6z",
    className: "st5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M735 417s-90 5-92 16-10 120-5 168c0 0 34 2 51-2l4-115 27-3 61-74-46 10z",
    className: "st7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M779 415s-70 19-72 30-10 109-5 156c0 0 37 2 53-2l5-109 15 1 39-67-35-9z",
    className: "st6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M733 602c16 0 22-2 23-3l4-109-7 3 1 2 5-3-4 106c-2 1-11 3-30 2v2h8z",
    className: "st4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M748 579c2-7 3-72 3-75h-2c0 1 0 68-2 74l1 1zM684 487c8-3 20-3 20-3v-2l-20 3v2z",
    className: "st4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M666 602c13 0 23-3 23-3h1l4-116-6 4 1 1 3-2-4 112c-2 1-11 3-24 2v2h2z",
    className: "st4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M683 581c2-10 0-78 0-81h-1v81h1zM802 492c16 0 35 0 57-2v-1c-64 5-107 0-108 0v1s20 2 51 2z",
    className: "st4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m780 380-51 21 10 19 28-6 13-34zM853 291s21-1 31 5c15 8 9 57 9 57s-12-7-13-9l-27-53z",
    className: "st8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m858 397-16 3h-1l1-1 15-3h1v1z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m866 388-10 4-10 5-17 3 2 2c-21 3-85 5-95 6-7 1-13 9-17 15l6 4 55-2-4 13c35 3 83 2 92-12 8-11 0-28-2-38z",
    style: {
      fill: "#f9b59d"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M873 295c-12-2-44-3-44-3h-3c-35 6-39 32-39 32l-17 75-19 2c-6 11-1 43-1 43l92 10s20 3 37-18c11-15 15-58 15-91 0 0-2-48-21-50z",
    className: "st10"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M615 353h87l31 78h-88z",
    className: "st4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M733 431h-4l-31-78h4z",
    className: "st4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M672 389c1 4 0 7-2 8s-5-1-6-5-1-7 2-8c2-1 5 2 6 5z",
    className: "st7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M762 424h-33v7h33c2 0 3-2 3-4v1c0-2-1-4-3-4z",
    className: "st4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M733 427h21v1h-21zM842 401l-1-1a1213 1213 0 0 0 1 0v1zM782 400l-1-1c1 0 15-45 18-61l1-1v1a896 896 0 0 1-18 62zM840 314h-1v-1c20-1 24-16 24-16v-1l1 1s-4 15-24 17z",
    className: "st4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m778 389-4-7 13-58s1-7 7-14c5-7 16-16 36-19v1c-20 3-30 11-35 18-6 8-7 14-7 14l-13 58 4 6-1 1z",
    className: "st4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m758 390-1-1v-1l17-6h1l-1 1-16 7z",
    className: "st4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M751 401s-6 14-1 43l22-12-7-22-14-9z",
    className: "st10"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M862 401c-1 0-83-2-110 0-1 2-4 11-3 28h-1c-1-19 2-28 3-29 27-2 110 0 111 0v1c1 0 0 0 0 0z",
    className: "st4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M824 248v25s-1 8 6 10l-1 10c-1 5 1 9 5 10l7 1c8 0 13-6 14-9s-1-18-1-18v-34l-30 5z",
    className: "st5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M847 276s-1 14-18 15l1-8s11 2 17-7z",
    className: "st11"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m856 259-8 1-1 1 2-15c2-2 7 13 7 13z",
    className: "st3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M845 263a6 6 0 1 0 7-6c-4 0-7 3-7 6z",
    className: "st5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m852 266 3-1-1-3h-3l1-2h3-3l-2 2v1-1h3l1 2-2 2z",
    className: "st11"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M856 259s2-12-2-17c-3-4-24-13-27-11-2 3 0 5 0 5s-8-3-10 5c-2 7 16 11 27 8 0 0 7 2 12 10z",
    className: "st3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m858 452-4 2-12 1-1-1h1l12-2c6-1 16-6 24-17 11-14 15-56 15-88l1-1v1c0 32-4 75-15 89-7 9-15 14-21 16z",
    className: "st4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M687 640h-37l-15-16-27 16h-6c-2 0-4 2-4 4s2 5 4 5h86l1-1v-6l-2-2z",
    className: "st2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M687 640v-15s-6-8-16-4c0 0-14 10-27-2l-31 14s-8 3-11 7h85z",
    className: "st4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M686 625h1v15h-1zM658 625h-2c1 0 8 1 15-4-5 4-10 4-13 4zM679 637l4-2-4 2zM676 636l4-2-4 2zM599 648l-1-4c0-2 2-4 4-4h85l2 2v5h-1v-5l-2-1h-84c-2 0-4 1-4 4l2 2-1 1zM602 640s2-4 8-6l34-15-34 15c-6 3-8 6-8 6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M752 640h-36l-15-16-28 16h-6l-4 4c0 2 2 5 4 5h86l1-1v-6l-2-2z",
    className: "st1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M752 640v-15s-6-8-16-4c0 0-14 10-27-2l-31 14s-8 3-11 7h85z",
    className: "st3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M752 625v15zM724 625h-2s7 1 14-4h1c-5 4-11 4-13 4zM744 637l5-3-5 3zM741 636l5-2-5 2zM665 648l-2-4c0-2 2-4 4-4h85l2 2v5-5l-2-1h-85c-2 0-4 1-4 4l2 2v1zM668 640h-1s2-4 8-6l34-15h1l-34 15c-7 3-8 6-8 6zM170 142s-6 5 1 20l3-3-3-7-1-10z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m199 145 5 22s3 8-4 10l4 10c1 4 0 8-4 10l-6 2c-7 2-13-3-14-5l-3-17-1-7-6-26 29 1z",
    className: "st5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M179 163c1 3-1 6-4 7s-6-1-7-4c-1-4 1-7 4-7 3-1 7 1 7 4z",
    className: "st5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m174 168-3-1 1-3 3-1-2-1-2 1v-1h2l2 2h1-4v2l2 2z",
    className: "st11"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M205 164s5 14-5 17c-14 4-17-4-20-10l-3-14v-4l2 3 5 13c1 0 18-6 21-5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m177 153-4-2-1 8s4 0 5 3 0 11 8 18c9 6-3-13-3-14l-5-13z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M170 142c3-4 13-8 21-6v1c10 2 9 11 9 11v1l-1-2-4-1-9-1c-4 0-6 2-8 3 0 2 0 6 3 13 4 12-5-1-8-6v4s-7-10-3-17z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m201 151-2-5c0-1-11-2-17 0-5 2 7 6 7 6l12-1zM179 148l-6-4 7 7zM173 641h-29v-26l28-4zM236 641h-28v-26l28-4zM237 403c-4 6-5 0-5 0-3 3-4 2-5 1v-2l5-14c-1-4-6-2-9-1-1 1-4 1-1-2 1-3 7-8 7-8l-2-18 24 2 1 23c0 3-2 13-5 17-4 6-5 2-5 2-5 6-5 0-5 0z",
    className: "st5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M235 396h-1c0 3-3 7-3 7h1l3-7c0 1 0 0 0 0zM240 397v-1h-1l-2 7c-1 0 0 0 0 0l3-6zM245 397h-1l-2 6h1l2-6c0 1 0 0 0 0z",
    className: "st11"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m254 368-1 9s-4 3-13 3l3-12h11z",
    className: "st12"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M186 342s4 176 17 277c0 0 17 6 39-4V356l4-39-60 25z",
    className: "st10"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M141 344s-7 173 1 275c0 0 16 10 38 2l27-249 11-67-77 39z",
    className: "st10"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M164 624c-12 0-22-4-22-4v-1c-8-39-3-231-3-233h1c0 2-4 193 3 233 2 1 20 8 37 1h1l-1 1c-5 2-11 3-16 3zM215 621l-12-1-1-1h1c20 4 36-4 38-5l1-243 1-2v2l-1 244s-11 6-27 6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M235 193s14 6 16 17 8 145 4 158h-21l1-175z",
    className: "st7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m134 270-1 86s67 19 110-3l-9-158c-2-8-45-8-63-6 0 0-28-1-42 7l5 74z",
    className: "st12"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M133 247v134s35 8 53 1c0 0-1-189-8-194 0 0-18 0-31 2-12 1-14 57-14 57zM207 188s3 166 7 190c0 0 14 1 33-5 0 0-4-173-8-178-5-4-32-7-32-7z",
    className: "st6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M133 290h-1v-28l1-1 1 1v28h-1zM186 383l-1-1a2273 2273 0 0 0-2-162s3 42 3 162v1zM247 374s-1 0 0 0l-1-1a2223 2223 0 0 0 1 1zM208 222l-1-1-1-34h1c1 0 30 2 38 12v1h-1c-7-9-32-11-36-12v34z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M88 311c3-18-5-30-10-36l-5 18c0 8 4 18 11 29l4-11z",
    className: "st1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M135 204c4-5 10-8 10-8h1-1s-6 2-10 7v1zM136 208v-1c4-5 10-7 10-7h1l-1-1s-7 2-11 8l1 1z",
    className: "st4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m152 623-1-1-1-69 1-1 1 1 1 69-1 1zM216 621h-1l-3-68v-1l1 1 4 67-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m122 416-1-1c-2-1-2-3-1-4l80-94 6 5-80 94h-4z",
    style: {
      fill: "#fedb69"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m193 325-71 83h1l70-83z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m200 317 9-5-3 10c-2 2-8-3-6-5z",
    style: {
      fill: "#f0f6ff"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m207 313 1 2 1-3-2 1z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M167 394c7 1 4-4 4-4 4 0 4-1 4-2l-1-2-14-7c-2-3 2-5 5-6 2-1 4-2 0-3h-11l-10-14-17 18 15 17c2 2 12 8 16 8 7 1 5-1 5-1 8 0 4-4 4-4z",
    className: "st5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m164 388-1-1h1c2 2 7 3 7 3l-7-2zM160 391h1l6 2v1l-7-3zM157 396v-1h1l5 2v1l-6-2z",
    className: "st11"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158 189s-29-3-43 21c-13 22-38 53-42 83-2 24 44 73 56 85l21-23s-34-53-37-60c-2-6 47-71 47-71l-2-35z",
    className: "st6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m129 377 4 6 19-17-5-8-18 19z",
    className: "st12"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M129 378h-1v-1l21-22a1065 1065 0 0 1-36-61h1l36 61h1-1l-21 23z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M102 299h-1l1-1c4 0 10-4 11-4 2-8 30-47 31-49h1v1s-30 41-31 48v1s-8 4-12 4zM88 254l-1-1 32-50c16-17 36-15 36-15l1 1-1 1s-19-3-35 14l-32 49v1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M207 644h25l10-11 18 11h5l2 2c1 2-1 3-2 3h-60v-4l2-1z",
    className: "st3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M207 644v-11c0 1 4-5 10-2 0 0 10 7 19-2l21 10s6 2 7 5h-57z",
    className: "st12"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M207 634v10zM226 634h1v-1s-5 1-9-2h-1l9 3zM209 640l3 1zM212 639l2 2zM264 644h1a2068 2068 0 0 1-29-15l23 11 5 4zM266 649l1-2c1-2-1-3-3-3h-57l-2 1v3h1v-3l1-1h57c2 0 3 1 3 2l-1 3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M143 644h25l10-11 19 11h4l2 2c1 2-1 3-2 3h-59v-4l1-1z",
    className: "st3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M143 644v-11c0 1 4-5 11-2 0 0 9 7 18-2l21 10s6 2 8 5h-58z",
    className: "st12"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M143 634v10zM162 634h2v-1s-6 1-10-2l8 3zM145 640l4 2zM148 639l2 2zM200 644h1a2068 2068 0 0 1-29-15l23 11 5 4zM203 649l1-2c0-2-2-3-3-3h-58l-2 1v3h1v-3l1-1h58l2 2-1 3h1z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m-120-172 3 68 57 67-13 11c-8-6-65-47-68-55-11-13-9-57-11-73l32-18z",
    className: "st10"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManApplying01);
export default __webpack_public_path__ + "static/media/man_applying-01.cc24764f838be0ff8d75b118820a21bf.svg";
export { ForwardRef as ReactComponent };